import React from 'react'
import Slider from 'rc-slider'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import NumberFormat from 'react-number-format'
import './MonthRowWithProrate.scss'

interface Props {
  year: number
  month: number
  maxPrice: number
  value: number
  disabled: boolean
  onChange: (value: number) => void
  proratedValue?: number
  isRestricted?: boolean
}

const MonthRowWithProrate: React.FC<Props> = props => {
  const { year, month, maxPrice, value, disabled, onChange, proratedValue, isRestricted } = props
  const { i18n } = useTranslation()

  moment.locale(i18n.language)

  const showProratedIndicator = proratedValue && proratedValue > 0

  const indicatorWidth = value > 0 && maxPrice > 0
    ? Math.min((proratedValue / maxPrice) * 100, (value / maxPrice) * 100)
    : (proratedValue / maxPrice) * 100

  return (
    <div className="row month-row form-group align-items-center">
      <label className="col-3 mb-0">
        {moment.monthsShort(month)} {`${year}`.slice(-2)}.
      </label>
      <div className="col-5 slider-container">
        {showProratedIndicator && isRestricted && (
          <div 
            className="prorated-indicator" 
            style={{ width: `${indicatorWidth}%` }}
          />
        )}
        <Slider
          max={maxPrice}
          value={value}
          onChange={onChange}
          disabled={disabled}
        />
      </div>
      <div className="col-4">
        <div className="input-group embed">
          <NumberFormat
            className="form-control"
            disabled={disabled}
            value={value}
            decimalScale={2}
            allowNegative={false}
            displayType={'input'}
            onChange={e => onChange(Number(e.target.value))}
            thousandSeparator={false}
          />
          <span className="input-group-addon">€</span>
          {showProratedIndicator && (
            <span className="input-group-addon prorated-badge">
              {isRestricted ? 'Incremental' : 'Disponible'}
            </span>
          )}
        </div>
      </div>
    </div>
  )
}

MonthRowWithProrate.defaultProps = {
  value: 0,
  proratedValue: 0,
  isRestricted: false
}

export default MonthRowWithProrate